import { forwardRef } from 'react';
import { FormError } from '~/components/Form/Error/FormError';
import { HelpText } from '~/components/HelpText';
import { Label } from '~/components/Label';
import styles from './Select.module.css';
import type { SelectProps } from './Select.types';

const Select = forwardRef<
  HTMLSelectElement,
  SelectProps & {
    errorMessage?: string;
  }
>(
  (
    {
      children,
      disabled,
      helpText,
      id,
      label,
      labelVariant = 'small',
      name,
      selected,
      required,
      errorMessage,
      ...props
    },
    ref
  ) => {
    const getDescriptors = () => (helpText ? `SelectHelpText-${id}-help` : undefined);

    return (
      <div>
        <Label id={id} disabled={disabled} variant={labelVariant} required={required}>
          {label}
        </Label>
        <div className={styles.selectWrapper}>
          {/* @ts-ignore */}
          <select
            name={name}
            id={id}
            disabled={disabled}
            aria-required={required || undefined}
            ref={ref}
            className={`${styles.select} ${errorMessage ? styles.selectError : ''}`}
            aria-describedby={getDescriptors()}
            data-test-id={`select-${id}`}
            value={selected}
            {...props}
          >
            {children}
          </select>
        </div>
        {helpText && (
          <div className={styles.helpText}>
            <HelpText id={`SelectHelpText-${id}`} disabled={disabled}>
              {helpText}
            </HelpText>
          </div>
        )}
        {errorMessage ? <FormError message={errorMessage} /> : null}
      </div>
    );
  }
);

Select.displayName = 'Select';

export { Select };
